import React from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';
import {
  formatDate,
  validateRequired,
  convertValueToNumber
} from '../../helpers';
import Input from '../../components/Input';

class ReferenceLayerDetailsForm extends React.Component {
  render() {
    return (
      <div>
        <Row />
        <Form onSubmit={this.props.handleSubmit}>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="text"
                  label="Reference Layer Label"
                  placeholder="Reference Layer Label"
                  name="label"
                  validate={validateRequired}
                />
              </Col>
            </FormGroup>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Version</ControlLabel>
              <FormControl.Static>
                {this.props.currentReferenceLayer.version}
              </FormControl.Static>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Type</ControlLabel>
              <FormControl.Static>
                {this.props.currentReferenceLayer.referenceLayerType}
              </FormControl.Static>
            </Col>
          </Row>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="select"
                  label="Visibility"
                  name="visibilityTypeId"
                  componentClass="select"
                  placeholder="select"
                  options={this.props.visibilityTypes}
                  validate={validateRequired}
                  normalize={convertValueToNumber}
                  sort
                  prompt
                />
              </Col>
            </FormGroup>
          </Row>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="number"
                  label="Sort Order"
                  placeholder="Sort Order"
                  name="sortOrder"
                  validate={validateRequired}
                  normalize={convertValueToNumber}
                />
              </Col>
            </FormGroup>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Ref Name</ControlLabel>
              <FormControl.Static>
                {this.props.currentReferenceLayer.refName}
              </FormControl.Static>
            </Col>
          </Row>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="text"
                  label="Attribution"
                  placeholder="Attribution"
                  name="attribution"
                  validate={validateRequired}
                />
              </Col>
            </FormGroup>
          </Row>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="textarea"
                  placeholder="Description"
                  name="description"
                  label="Description"
                  rows="4"
                />
              </Col>
            </FormGroup>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="toggle"
                name="allowExactBoundaryMatch"
                label="Allow Exact Boundary Match"
                disabled={
                  !this.props.currentReferenceLayer.canAllowExactBoundaryMatch
                }
              />
            </Col>
          </Row>
          <div>
            <Row>
              <Col sm={12} className="form-input">
                <ControlLabel>Date created</ControlLabel>
                <FormControl.Static>
                  {formatDate(this.props.currentReferenceLayer.dateCreated)}
                </FormControl.Static>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="form-input">
                <ControlLabel>Last changed</ControlLabel>
                <FormControl.Static>
                  {formatDate(this.props.currentReferenceLayer.dateUpdated)}
                </FormControl.Static>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="form-input">
                <ControlLabel>Last changed by</ControlLabel>
                <FormControl.Static>
                  {this.props.currentReferenceLayer.lastChangedBy}
                </FormControl.Static>
              </Col>
            </Row>
          </div>
          <Row>
            <Col sm={2} className="table-header table-header--multi-buttons">
              <Button
                bsStyle="primary"
                type="submit"
                disabled={this.props.isSaving}
              >
                {this.props.isSaving ? 'Saving...' : 'Save'}
              </Button>
              <Button
                bsStyle="secondary"
                disabled={this.props.isDeleting}
                onClick={() =>
                  this.props.handleDelete(this.props.currentReferenceLayer.id)
                }
              >
                Delete
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={12}>
              <CSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
              >
                {this.props.successMsg && (
                  <p className="text-success">{this.props.successMsg}</p>
                )}
              </CSSTransitionGroup>
            </Col>
          </Row>
        </Form>
        {this.props.errorMsg && (
          <div className="alert alert-danger">{this.props.errorMsg}</div>
        )}
      </div>
    );
  }
}

// Decorate the form component
ReferenceLayerDetailsForm = reduxForm({
  form: 'referenceLayerDetailsForm' // a unique name for this form
})(ReferenceLayerDetailsForm);

export default ReferenceLayerDetailsForm;



// WEBPACK FOOTER //
// ./src/containers/referenceLayers/ReferenceLayerDetailsForm.js